import { ApolloClient, createHttpLink, InMemoryCache, makeVar } from '@apollo/client';
import { SESSIONSTORAGE_TOKEN } from './components/constants';

//Local-only fields는 GraphQL 서버의 스키마에 정의되지 않는 것
//Apollo Client는 GraphQL State를 다룰 수 있다. Local State(ex: login) Client Cache에 보관
//Local State ? -> Server에 보낼 필요 없이 Client만 가지고 있어도 되는 정보

//redux 끝났따!!

const token = sessionStorage.getItem(SESSIONSTORAGE_TOKEN);

//reactive variables는 어디에서나 읽고 쓸 수 있다.(GLOBAL)
export const isLoggedInVar = makeVar(Boolean(token)); // defaultvalue:false
export const jwtToken = makeVar(token); // defaultvalue:null

// console.log('default value is', isLoggedInVar());
// console.log('default value is', jwtToken());

//console.log(process.env.REACT_APP_BACKEND_ENDPOINT);
const httpLink = createHttpLink({
    uri: `${process.env.REACT_APP_BACKEND_ENDPOINT}/graphql`,
});

export const client = new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache({
        typePolicies: {
            Query: {
                fields: {
                    isLoggedIn: {
                        read() {
                            return isLoggedInVar();
                        },
                    },
                    token: {
                        read() {
                            return jwtToken();
                        },
                    },
                },
            },
        },
    }),
});
